<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card h-100 mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t("content.rpjor7") }}</h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-2">
                <label class="form-label ms-0">{{ $t("content.year") }}</label>
                <select v-model="years_search" class="form-select">
                    <option value="" disabled selected>{{ $t('content.select') }}</option>
                    <option v-for="(a, sel2) in years" :key="sel2" :value="a">
                    {{ a.items }}
                    </option>
                </select>
                </div>

            <div class="col-lg-2">
                <label class="form-label ms-0">{{ $t("content.month") }}</label>
                <select v-model="months_search" class="form-select">
                    <option value="" disabled selected>{{ $t('content.select') }}</option>
                    <option v-for="(a, sel3) in datas.optMonths" :key="sel3" :value="a.value">
                    {{ a.items }}
                    </option>
                </select>
            </div>
            <div class="col-lg-2">
                <label class="form-label ms-0 png"></label>
                <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                    :disabled="years_search === '' || months_search === ''" @click="loadDataApi">
                    <i class="material-icons material-symbols-outlined">search</i>
                    {{ btnSearch }}
                </material-button>
            </div>

            </div>
            <div class="row mt-3">  
              <div class="col-12 d-flex mt-4">
                <material-button
                  v-for="(i, exp) in exportFile"
                  :key="exp"
                  :color="i.cl"
                  variant="outline"
                  class="float-lg-start float-sm-end mb-0 me-2"
                  :class="i.cs"
                >
                  <i class="material-icons material-symbols-outlined">{{ i.ic }}</i>
                  {{ btnPrint }} {{ i.nm }}
                </material-button>
              </div>
            </div>
            <div class="row mt-3">
                <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th class="text-center">{{ $t("content.numofCustomer") }}</th>
                          <th class="text-center">{{ $t("content.numOfPawn") }}</th>
                          <th class="text-center">{{ $t("content.numOfPawnValue") }}</th>
                          <th class="text-center">{{ $t("content.numOfRedeem") }}</th>
                          <th class="text-center">{{ $t("content.numOfRedeemValue") }}</th>
                          <th class="text-center">{{ $t("content.numOfBreaking") }}</th>
                          <th class="text-center">{{ $t("content.numOfBreakingValue") }}</th>
                          <th class="text-center">{{ $t("content.numOfInterest") }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="listdata === null">
                            <td colspan="12" class="text-center py-4 text-sm text-secondary">
                                {{ $t("content.amnnodata") }}
                            </td>
                        </tr>
                        <tr v-for="(item, index) in listdata" :key="index">
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberString(item.numOfCus) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberString(item.numOfPawn) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberDecimalString(item.pawnValue) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberString(item.numOfRedeem) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberDecimalString(item.redeemValue) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberString(item.numOfBreaking) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberDecimalString(item.breakingValue) }}</td>
                          <td class="text-sm font-weight-normal border-0 text-center">{{ formatNumberDecimalString(item.interest) }}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
                <div class="row mt-3">
                <div class="col-12 d-flex justify-content-end align-items-center gap-2">
                    <material-button color="primary" class="mb-3" @click="j7PdfGen" :disabled="listdata === null">
                    <i class="material-icons material-symbols-outlined">download</i>
                    จ.7 PDF
                    </material-button>
                    <material-button color="success" class="mb-3" @click="s601PdfGen" :disabled="listdata === null">
                    <i class="material-icons material-symbols-outlined">download</i>
                    สง.601 PDF
                    </material-button>
                </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, computed, ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import moment from 'moment'
import axios from "axios";
import * as st from "@/config/setting.js";

import { useJ7Store } from '@/stores/j7'
import { useShopLicenseStore } from '@/stores/shoplicense'
import { useShopStore } from '@/stores/shop'


const storej = useJ7Store()
const storeshl = useShopLicenseStore()
const storesh = useShopStore()

const { t } = useI18n();
const swal = inject("$swal");

const datas = reactive({
  optMonths: [
    { items: computed(() => t("opts.mon1")), value: '01' },
    { items: computed(() => t("opts.mon2")), value: '02' },
    { items: computed(() => t("opts.mon3")), value: '03' },
    { items: computed(() => t("opts.mon4")), value: '04' },
    { items: computed(() => t("opts.mon5")), value: '05' },
    { items: computed(() => t("opts.mon6")), value: '06' },
    { items: computed(() => t("opts.mon7")), value: '07' },
    { items: computed(() => t("opts.mon8")), value: '08' },
    { items: computed(() => t("opts.mon9")), value: '09' },
    { items: computed(() => t("opts.mon10")), value: '10' },
    { items: computed(() => t("opts.mon11")), value: '11' },
    { items: computed(() => t("opts.mon12")), value: '12' },
  ],
});

const years_search = ref('');
const months_search = ref('');
const listdata = ref(null);
const shop_detail = ref(null);
const shop_info = ref(null);
const loading = ref(false);
const key = JSON.parse(localStorage.getItem("shop_seleted"));

const btnSearch = computed(() => t("buttons.sear"));

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY');
}

const formatyear = (date) => {
  return moment(String(date)).local().format('YYYY');
}

const currentYear = new Date().getFullYear();
const years = ref([
  { items: formatyear(new Date(new Date().setFullYear(new Date().getFullYear() - 0))) },
  { items: formatyear(new Date(new Date().setFullYear(new Date().getFullYear() - 1))) },
]);

const infoshop = async (val) => {
  let data = "";
  shop_detail.value = null
  data = {
    index: "0",
    size: "1",
    shopUid: key.uid,
    validYear: formatyear(new Date(new Date().setFullYear(new Date().getFullYear() - 0)))
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storeshl.shopLicenseListFetch(payload);
  // console.log('info res : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data.list[0]
        getShopInfo(shop_detail.value.shopUid)
      }
    }
  }
}

infoshop()


const loadDataApi = async (val) => {
  listdata.value = null  
  let data = "";
  data = {
    groupUid: key.groupUid,
    shopUid: key.uid,
    year: years_search.value.items,
    month: Number(months_search.value)
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storej.j7SummaryFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          listdata.value = [response.data.data] 
      }
    }
  }
}


async function getShopInfo(uid) {
    shop_info.value = null
    let data = "";
    data = {
        uid: uid,
    };
    const payload = data;
    const response = await storesh.shopInfoFetch(payload);
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_info.value = response.data.data
                // console.log('shop_info : ' + JSON.stringify(shop_info.value));
            }
        }
    }
}

async function j7PdfGen() {
    loading.value = true
    let data = "";
    data = {
        groupUid: key.groupUid,
        shopUid: key.uid,
        year: years_search.value.items,
        month: Number(months_search.value),
        shopName: shop_info.value?.fullname || "",
        shopAddr: shop_info.value?.address || "",
        shopLicense: shop_detail.value 
        ? `ใบอนุญาติตั้งโรงรับจำนำเล่มที่ ${shop_detail.value.licenseBookNo || ""} เลขที่ ${shop_detail.value.licenseNo || ""}`
        : "",
        stampImgUid: shop_info.value?.stampImgUid || "0"// if no image set this value to 0
    };
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/j7/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}

async function s601PdfGen() {
    loading.value = true
    let data = "";
    let addressComponents = {
      no: "",
      soi: "",
      moo: "",
      road: "",
      subDistrict: "",
      district: "",
      province: ""
    };
    if (shop_info.value && shop_info.value.address) {
      addressComponents = parseThaiAddressDynamic(shop_info.value.address);
    }
    data = {
        groupUid: key.groupUid,
        shopUid: key.uid,
        year: years_search.value.items,
        month: Number(months_search.value),
        to: "อธิบดีกรมการปกครอง",
        shopName: shop_info.value?.fullname || "",
        no: addressComponents?.no || "",
        soi: addressComponents?.soi || "",
        moo: addressComponents?.moo || "",
        road: addressComponents?.road || "",
        subDistrict: addressComponents?.subDistrict || "",
        district: addressComponents?.district || "",
        province: addressComponents?.province || "",
        phone: shop_info.value?.shopPhoneNumber || "",
        stampImgUid: shop_info.value?.stampImgUid || "0"// if no image set this value to 0
    };
    const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
    const accessToken = keya.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/pawn-rpt-svc/j7/s601/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}

const parseThaiAddressDynamic = (fullAddress) => {
  if (!fullAddress) {
    return { no: "", soi: "", moo: "", road: "", subDistrict: "", district: "", province: "" };
  }

  // ล้างช่องว่างซ้ำซ้อน
  const cleanAddress = fullAddress.replace(/\s+/g, ' ').trim();

  // 1. ตรวจสอบจังหวัดและรหัสไปรษณีย์ก่อน (เพราะมักจะอยู่ท้ายสุด แยกง่ายสุด)
  let province = "";
  if (cleanAddress.includes("กรุงเทพ") || cleanAddress.includes("กทม")) {
    province = "กรุงเทพมหานคร";
  } else {
    const provinceMatch = cleanAddress.match(/(?:จังหวัด|จ\.)\s*([\u0E00-\u0E7F]+)/);
    // ถ้าไม่มีคำว่า จังหวัด/จ. นำหน้า ให้ดึงคำก่อนรหัสไปรษณีย์มาพิจารณาแทน
    if (provinceMatch) {
      province = provinceMatch[1].trim();
    } else {
      const zipMatch = cleanAddress.match(/([\u0E00-\u0E7F]+)\s+\d{5}\s*$/);
      province = zipMatch ? zipMatch[1].trim() : "";
    }
  }

  // 2. ดึงข้อมูลพื้นฐานด้วยรูปแบบคำนำหน้า (Prefix)
  const mooMatch = cleanAddress.match(/(?:หมู่ที่|หมู่)\s*(\d+)/);
  const soiMatch = cleanAddress.match(/(?:ซอย|ซ\.)\s*([\u0E00-\u0E7F\w\s./-]+?)(?=\s*(?:ถนน|ถ\.|หมู่|ต\.|อ\.|จ\.|เขต|อำเภอ|ตำบล|แขวง|กรุงเทพ|$))/);
  const roadMatch = cleanAddress.match(/(?:ถนน|ถ\.)\s*([\u0E00-\u0E7F\w\s./-]+?)(?=\s*(?:หมู่|ซอย|ซ\.|ต\.|อ\.|จ\.|เขต|อำเภอ|ตำบล|แขวง|กรุงเทพ|$))/);

  // 3. ดึง อำเภอ/เขต และ ตำบล/แขวง แบบ Dynamic (ดักจับทั้งแบบมี Prefix และไม่มี Prefix ด้วยการ split ช่องว่าง)
  let subDistrict = "";
  let district = "";

  // ลองดึงด้วยคำนำหน้าก่อน (ต. / แขวง / ตำบล)
  const subDistrictMatch = cleanAddress.match(/(?:ตำบล|ต\.|แขวง)\s*([\u0E00-\u0E7F]+)/);
  // ลองดึงด้วยคำนำหน้า (อำเภอ / อ. / เขต)
  const districtMatch = cleanAddress.match(/(?:อำเภอ|อ\.|เขต)\s*([\u0E00-\u0E7F]+)/);

  if (subDistrictMatch) subDistrict = subDistrictMatch[1].trim();
  if (districtMatch) district = districtMatch[1].trim();

  // ปลั๊กอินอัจฉริยะ: กรณีไม่มีคำว่า "เขต/อำเภอ/ตำบล" นำหน้าเลย (เช่น "18 ถนนนาคนิวาส ลาดพร้าว กรุงเทพฯ")
  if (!subDistrict || !district) {
    const tokens = cleanAddress.split(" ");
    // วนลูปหาคำที่น่าจะเป็น เขต/อำเภอ/ตำบล โดยดูจากคำที่อยู่ก่อนหน้า "กรุงเทพ/จังหวัด"
    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      // ข้ามคำที่เป็นตัวเลข หรือคำพิกัดหลักที่แกะไปแล้ว
      if (/^\d/.test(token) || token.startsWith("ถนน") || token.startsWith("ถ.") || token.startsWith("ซอย") || token.startsWith("ซ.")) continue;
      if (token.includes("กรุงเทพ") || token.includes("กทม") || token.startsWith("จังหวัด") || token.startsWith("จ.") || /\d{5}/.test(token)) continue;

      // ล้างคำนำหน้าออกเพื่อเอาคำดิบๆ มาประมวลผล
      const cleanToken = token.replace(/^(ตำบล|ต\.|แขวง|อำเภอ|อ\.|เขต)/, "");

      if (!district && (token.startsWith("เขต") || token.startsWith("อำเภอ") || token.startsWith("อ."))) {
        district = cleanToken;
      } else if (!subDistrict && (token.startsWith("ตำบล") || token.startsWith("ต.") || token.startsWith("แขวง"))) {
        subDistrict = cleanToken;
      } else {
        // หากไม่มีคำนำหน้าเลย ให้คำนวณจากตำแหน่งเทียบกับจังหวัด
        if (!district) district = cleanToken;
        else if (!subDistrict) subDistrict = cleanToken;
      }
    }
  }

  // 4. แยกเลขที่บ้าน (คำแรกสุดของประโยค)
  const firstSpaceIndex = cleanAddress.indexOf(" ");
  const houseNo = firstSpaceIndex !== -1 ? cleanAddress.substring(0, firstSpaceIndex).trim() : cleanAddress;

  // 5. ปรับ Format คำนำหน้า เขต/อำเภอ ให้ถูกต้องและสวยงามตามรูปแบบจังหวัด
  let finalDistrict = district;
  if (finalDistrict) {
    if (province === "กรุงเทพมหานคร") {
      finalDistrict = finalDistrict.startsWith("เขต") ? finalDistrict : `เขต${finalDistrict}`;
    } else {
      finalDistrict = finalDistrict.startsWith("อำเภอ") ? finalDistrict : `อำเภอ${finalDistrict}`;
    }
  }

  return {
    no: houseNo,
    soi: soiMatch ? soiMatch[1].trim() : "",
    moo: mooMatch ? mooMatch[1].trim() : "",
    road: roadMatch ? `ถนน${roadMatch[1].trim()}` : "",
    subDistrict: subDistrict,
    district: finalDistrict,
    province: province
  };
};
</script>  
<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style> 